import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=7ca3ebda&scoped=true"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&id=7ca3ebda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca3ebda",
  null
  
)

export default component.exports